import { lang } from '@ott/l10n';
import superagent from '@ott/superagent';
import { isLocalStorageAvailable } from '@ott/utility-localstorage';

const LOCAL_STORAGE_KEY = 'OTT/common/crossSearch';
const VERTICAL_KEYS = {
  avia: 'avia',
  hotel: 'hotel',
};

let isLoading = false;

const setData = (data) => {
  if (isLocalStorageAvailable) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
  }
};
const getData = () => {
  let result = {};
  if (isLocalStorageAvailable) {
    result = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
  }

  return result;
};
const getDates = () => {
  try {
    const { dateStart, dateEnd } = getData();
    if (!dateStart) {
      return null;
    }
    const dateStartObj = new Date(dateStart);
    let dateEndObj;
    if (dateEnd) {
      dateEndObj = new Date(dateEnd);
    } else {
      dateEndObj = new Date(dateStartObj);
      dateEndObj.setDate(dateStartObj.getDate() + 1);
    }

    const dateNow = new Date();
    // Одинаковая дата для одного дня
    dateNow.setHours(0, 0, 0, 0);

    if (dateNow > dateEndObj) {
      return null;
    }

    if (dateNow > dateStartObj) {
      return {
        dateStart: dateNow,
        dateEnd: dateEndObj,
      };
    }

    return {
      dateStart: dateStartObj,
      dateEnd: dateEndObj,
    };
  } catch (e) {
    return null;
  }
};

const loadAvia = async (code) => {
  const {
    body: { result },
  } = await superagent.get('/_hotels/api/city/').query({ iata: code, lang });
  const answer = {};

  if (result) {
    answer[VERTICAL_KEYS.hotel] = result;
  }

  return answer;
};

const loadHotel = async (lat, lng) => {
  const { body } = await superagent.get('/_avia/ipinfo/get/').query({ lon: lng, lat });
  const answer = {};

  if (body) {
    answer[VERTICAL_KEYS.avia] = body;
  }

  return answer;
};

/* Так как загрузить информацию при переходе с front-index
   мы не можем дожидаться загрузки информации, то он запускается
   на странице поиска  */
const loadingInfo = async () => {
  if (isLoading) {
    return;
  }

  try {
    const { meta, ...info } = getData();

    if (!meta) {
      return;
    }

    isLoading = true;
    const { product, code, lat, lng } = meta;

    switch (product) {
      case VERTICAL_KEYS.avia:
        loadAvia(code).then((result) => {
          setData({
            ...info,
            ...result,
          });
          isLoading = false;
        });
        break;

      case VERTICAL_KEYS.hotel:
        loadHotel(lat, lng).then((result) => {
          setData({
            ...info,
            ...result,
          });
          isLoading = false;
        });
        break;

      default:
        isLoading = false;
    }
  } catch (e) {
    console.error(e);
  }
};

const setAvia = ({ code, dateStart, dateEnd, adults, childrenAges }) => {
  setData({
    adults,
    childrenAges,
    dateStart,
    dateEnd,
    meta: {
      product: VERTICAL_KEYS.avia,
      code,
    },
  });
  isLoading = false;
  loadingInfo();
};

const setHotel = ({ lat, lng, dateStart, dateEnd, adults, childrenAges }) => {
  setData({
    adults,
    childrenAges,
    dateStart,
    dateEnd,
    meta: {
      product: VERTICAL_KEYS.hotel,
      lat,
      lng,
    },
  });
  isLoading = false;
  loadingInfo();
};

const getAvia = () => {
  try {
    const data = getData();
    const aviaData = data[VERTICAL_KEYS.avia];
    if (!aviaData) {
      return null;
    }
    const dates = getDates();
    if (!dates) {
      return null;
    }

    const { adults, childrenAges } = data;
    const { nearCityCode } = aviaData;

    // для авии дети старше 11 лет считаются взрослыми
    let adultsCount = adults;
    const youngChildrenAges = [];
    childrenAges.forEach((age) => {
      if (age > 11) {
        adultsCount += 1;
      } else {
        youngChildrenAges.push(age);
      }
    });

    return {
      adultsCount,
      childrenAges: youngChildrenAges,
      flights: [
        {
          dates: {
            fromDate: dates.dateEnd,
            toDate: dates.dateStart,
          },
          from: {},
          to: { text: nearCityCode, code: nearCityCode },
        },
      ],
    };
  } catch (e) {
    return null;
  }
};

const getHotel = () => {
  try {
    const data = getData();
    const hotelData = data[VERTICAL_KEYS.hotel];
    if (!hotelData) {
      return null;
    }
    const dates = getDates();
    if (!dates) {
      return null;
    }

    const { adults, childrenAges } = data;
    const { name, country_code: countryCode, id, timezone_gmt: timezoneGmt, type } = hotelData;

    return {
      startDate: dates.dateStart,
      endDate: dates.dateEnd,
      to: {
        country_code: countryCode,
        id,
        timezone_gmt: timezoneGmt,
        type,
        name,
      },
      rooms: [
        {
          adults,
          childrenAges,
        },
      ],
    };
  } catch (e) {
    return null;
  }
};

const crossSearch = {
  setAvia,
  setHotel,
  getHotel,
  getAvia,
  loadingInfo,
};

export default crossSearch;
